module.exports = __webpack_public_path__ + "static/media/8_1.7cfec1d1.png";